/* Rekover v26 : grand mot REKOVER en métal liquide + collections en arc.
   Ressorts, glisser et scroll : Motion (Framer Motion, motion.dev). Repli intégré si Motion manque. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var M = function () { return window.Motion || null; };
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  /* Ressort sur un nombre : Motion si présent, sinon petit ressort maison */
  function spring(from, to, opts, onUpdate) {
    var m = M();
    if (m && m.animate) {
      try {
        return m.animate(from, to, { type: 'spring', stiffness: opts.stiffness || 170, damping: opts.damping || 26, velocity: opts.velocity || 0, restDelta: 0.0005, onUpdate: onUpdate });
      } catch (e) { /* repli */ }
    }
    var x = from, v = opts.velocity || 0, k = opts.stiffness || 170, c = opts.damping || 26, stop = false, last = performance.now();
    (function tick(now) {
      if (stop) return;
      var dt = Math.min(0.032, (now - last) / 1000); last = now;
      var a = -k * (x - to) - c * v; v += a * dt; x += v * dt;
      if (Math.abs(v) < 0.001 && Math.abs(x - to) < 0.0005) { onUpdate(to); return; }
      onUpdate(x); requestAnimationFrame(tick);
    })(last);
    return { stop: function () { stop = true; } };
  }

  /* Reflet du métal miroir qui suit la souris (ordinateur) */
  function chromeFollow(el, area) {
    if (!fine || reduce || !el || el.dataset.follow) return;
    el.dataset.follow = '1';
    var tx = 50, ty = 30, cx = 50, cy = 30, raf = 0;
    var loop = function () {
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      el.style.setProperty('--mx', cx.toFixed(2) + '%'); el.style.setProperty('--my', cy.toFixed(2) + '%');
      raf = (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) ? requestAnimationFrame(loop) : 0;
    };
    (area || window).addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      if (!r.width) return;
      tx = clamp((e.clientX - r.left) / r.width * 100, -20, 120); ty = clamp((e.clientY - r.top) / r.height * 100, -40, 140);
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
  }

  /* ---------- 0. Accueil 3D : le mot REKOVER au-dessus de la goutte ---------- */
  function initH24Word() {
    var word = d.querySelector('.h24__word');
    if (!word) return;
    var sec = word.closest('[data-h24]'), track = sec && sec.querySelector('.h24__track');
    var tag = sec && sec.querySelector('.h24__tag');
    html.classList.add('rk-has-word');
    // le logo du header reste caché tant que le mot est affiché
    var tick = false;
    function check() {
      tick = false;
      if (!track) return;
      var top = track.getBoundingClientRect().top + window.scrollY;
      var lim = top + Math.max(80, 0.05 * (track.offsetHeight - window.innerHeight));
      html.classList.toggle('rk-word-on', window.scrollY < lim);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    check();
    chromeFollow(word.querySelector('.rk-chrome'), sec);
    if (reduce) return;
    var m = M(), ls = getComputedStyle(word).letterSpacing;
    if (m && m.animate) {
      m.animate(word, { opacity: [0, 1], letterSpacing: ['0.3em', ls], y: [14, 0] }, { duration: 1.15, delay: 0.2, ease: [0.16, 1, 0.3, 1] });
      if (tag) m.animate(tag, { opacity: [0, 1], y: [12, 0] }, { duration: 0.8, delay: 0.6, ease: [0.16, 1, 0.3, 1] });
    } else if (word.animate) {
      word.animate([{ opacity: 0, letterSpacing: '0.3em' }, { opacity: 1, letterSpacing: ls }], { duration: 1150, delay: 200, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
      if (tag) tag.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }], { duration: 800, delay: 600, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
    }
  }

  /* ---------- 1. Le grand mot REKOVER ---------- */
  function initHero() {
    var hero = d.querySelector('[data-rk-hero]');
    if (!hero) return;
    var word = hero.querySelector('[data-rk-word]');
    var items = $$('[data-rk-hero-item]', hero);
    var m = M();
    html.classList.add('rk-has-word');

    // le logo du header n'apparaît que quand le grand mot quitte l'écran
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { html.classList.toggle('rk-word-on', e[0].isIntersecting); }, { rootMargin: '-72px 0px 0px 0px' }).observe(word);
    }
    if (reduce) { html.classList.remove('rk-pre'); hero.classList.add('is-in'); return; }

    chromeFollow(word.querySelector('.rk-hero__wordtext'), hero);

    // arrivée : les lettres se resserrent (≈1,1 s)
    hero.classList.add('is-in');
    var ws = { opacity: [0, 1], letterSpacing: ['0.32em', getComputedStyle(word).letterSpacing], scale: [1.04, 1] };
    if (m && m.animate) {
      m.animate(word, ws, { duration: 1.15, ease: [0.16, 1, 0.3, 1] });
      m.animate(items, { opacity: [0, 1], y: [18, 0] }, { duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: m.stagger ? m.stagger(0.08, { startDelay: 0.45 }) : 0.45 });
    } else if (word.animate) {
      word.animate([{ opacity: 0, letterSpacing: ws.letterSpacing[0], transform: 'scale(1.04)' }, { opacity: 1, letterSpacing: ws.letterSpacing[1], transform: 'none' }], { duration: 1150, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
      items.forEach(function (el, i) { el.animate([{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'none' }], { duration: 800, delay: 450 + i * 80, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' }); });
    }

    html.classList.remove('rk-pre');

    // en scrollant : le mot recule doucement et s'efface
    if (m && m.scroll) {
      var inner = hero.querySelector('.rk-hero__inner');
      m.scroll(function (p) {
        inner.style.transform = 'translate3d(0,' + (p * -60).toFixed(1) + 'px,0) scale(' + (1 - p * 0.06).toFixed(4) + ')';
        inner.style.opacity = (1 - p * 0.9).toFixed(3);
      }, { target: hero, offset: ['start start', 'end start'] });
    }
  }

  /* ---------- 2. Collections en arc / panorama courbé ---------- */
  function initArc(sec) {
    if (sec.dataset.arcReady) return;
    sec.dataset.arcReady = '1';
    var style = sec.getAttribute('data-style') || 'arc';
    var stage = sec.querySelector('[data-arc-stage]'), ring = sec.querySelector('[data-arc-ring]');
    var cards = $$('[data-arc-card]', ring);
    var n = cards.length;
    if (!n) return;
    // assez de cartes pour faire le tour : on duplique (copies invisibles pour les lecteurs d'écran)
    var all = cards.slice();
    var minCount = style === 'arc' ? 9 : 8;
    while (all.length < minCount) {
      cards.forEach(function (c) {
        var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.setAttribute('tabindex', '-1'); k.removeAttribute('data-shopify-editor-block');
        ring.appendChild(k); all.push(k);
      });
    }
    var N = all.length;
    all.forEach(function (c, i) { c._i = i; c._src = i % n; });

    var nameEl = sec.querySelector('[data-arc-name]'), textEl = sec.querySelector('[data-arc-text]'), countEl = sec.querySelector('[data-arc-count]');
    var cta = sec.querySelector('[data-arc-cta]'), ctaName = sec.querySelector('[data-arc-cta-name]');
    var activeBox = sec.querySelector('[data-arc-active]');
    var dots = sec.querySelector('[data-arc-dots]');
    if (dots) { for (var k = 0; k < n; k++) dots.appendChild(d.createElement('i')); }

    var pos = 0, spread = reduce ? 1 : 0.62, anim = null, active = -1, geo = {};

    function measure() {
      var w = stage.clientWidth, mob = w < 750;
      if (style === 'arc') {
        var size = mob ? Math.round(clamp(w * 0.4, 120, 170)) : Math.round(clamp(w * 0.16, 170, 250));
        geo = { size: size, R: mob ? Math.max(420, w * 1.15) : clamp(w * 0.62, 640, 1000), step: mob ? 0.4 : 0.27, vis: mob ? 2.4 : 3.3 };
        sec.style.setProperty('--arc-card', size + 'px');
      } else {
        var pw = mob ? Math.round(clamp(w * 0.27, 92, 120)) : Math.round(clamp(w * 0.095, 118, 150));
        var R = pw * (mob ? 2.1 : 2.4);
        geo = { pw: pw, ph: Math.round(pw * (mob ? 1.3 : 1.12)), R: R, step: (pw + (mob ? 8 : 10)) / R, P: R * 2.4, k: 1.4, vis: 1.25 };
        sec.style.setProperty('--arc-pw', pw + 'px'); sec.style.setProperty('--arc-ph', geo.ph + 'px');
        stage.style.perspective = Math.round(geo.P) + 'px';
      }
    }

    function wrap(x) { var h = N / 2; x = ((x + h) % N + N) % N - h; return x; }

    function layout() {
      for (var i = 0; i < N; i++) {
        var c = all[i], dlt = wrap(i - pos), t, o, z = 0;
        if (style === 'arc') {
          var th = dlt * geo.step * spread;
          var x = geo.R * Math.sin(th), y = geo.R * (1 - Math.cos(th));
          var s = 0.86 + 0.14 * spread + (Math.abs(dlt) < 0.5 ? (0.5 - Math.abs(dlt)) * 0.16 : 0);
          o = clamp(geo.vis + 0.6 - Math.abs(dlt), 0, 1);
          t = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + (th * 57.2958).toFixed(2) + 'deg) scale(' + s.toFixed(3) + ')';
          z = 100 - Math.round(Math.abs(dlt) * 10);
        } else {
          var a = dlt * geo.step * (0.55 + 0.45 * spread);
          var R = geo.R, Z0 = geo.P - geo.k * R;
          var px = R * Math.sin(a), pz = Z0 - R * Math.cos(a);
          o = clamp((geo.vis - Math.abs(a)) * 4, 0, 1);
          t = 'translate3d(' + px.toFixed(1) + 'px,0,' + pz.toFixed(1) + 'px) rotateY(' + (-a * 57.2958).toFixed(2) + 'deg)';
        }
        c.style.transform = t;
        c.style.opacity = o.toFixed(3);
        c.style.zIndex = z;
        var hidden = o < 0.05;
        if (hidden !== c._hid) { c._hid = hidden; c.style.visibility = hidden ? 'hidden' : ''; }
      }
      var idx = ((Math.round(pos) % N) + N) % N, src = idx % n;
      if (src !== active) setActive(src, idx);
    }

    function setActive(src, idx) {
      var first = active < 0;
      active = src;
      all.forEach(function (c) { c.classList.toggle('is-active', c._i === idx); });
      var c = cards[src];
      if (dots) $$('i', dots).forEach(function (dot, i) { dot.classList.toggle('is-on', i === src); });
      if (first || !activeBox) return fill(c);
      var m = M();
      if (reduce || !m || !m.animate) return fill(c);
      if (activeBox._a) activeBox._a.stop && activeBox._a.stop();
      activeBox._a = m.animate(activeBox, { opacity: 0, y: -6 }, { duration: 0.14, ease: 'easeIn' });
      var p = activeBox._a.finished || (activeBox._a.then ? activeBox._a : null);
      var go = function () { if (active !== src) return; fill(c); activeBox._a = m.animate(activeBox, { opacity: [0, 1], y: [8, 0] }, { type: 'spring', stiffness: 260, damping: 26 }); };
      if (p && p.then) p.then(go, go); else setTimeout(go, 150);
    }
    function fill(c) {
      if (nameEl) nameEl.textContent = c.getAttribute('data-title');
      if (textEl) textEl.textContent = c.getAttribute('data-text') || '';
      if (countEl) countEl.textContent = c.getAttribute('data-count') || '';
      if (cta) cta.setAttribute('href', c.getAttribute('href'));
      if (ctaName) ctaName.textContent = c.getAttribute('data-title');
    }

    function goTo(target, vel) {
      if (anim && anim.stop) anim.stop();
      if (reduce) { pos = target; layout(); return; }
      anim = spring(pos, target, { stiffness: 150, damping: 24, velocity: vel || 0 }, function (v) { pos = v; layout(); });
    }
    function nearest(target) { return Math.round(target); }
    function step(dir) { goTo(nearest(pos) + dir); }

    var prev = sec.querySelector('[data-arc-prev]'), next = sec.querySelector('[data-arc-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // clic : une carte de côté vient au centre, la carte du centre ouvre la collection
    var moved = false;
    ring.addEventListener('click', function (e) {
      var c = e.target.closest('[data-arc-card]'); if (!c) return;
      if (moved) { e.preventDefault(); return; }
      var dlt = wrap(c._i - pos);
      if (Math.abs(dlt) > 0.5) { e.preventDefault(); goTo(pos + Math.round(dlt)); }
    });
    // clavier : la carte qui reçoit le focus vient au centre
    ring.addEventListener('focusin', function (e) {
      var c = e.target.closest('[data-arc-card]'); if (!c || moved) return;
      var dlt = wrap(c._i - pos); if (Math.abs(dlt) > 0.5) goTo(pos + Math.round(dlt));
    });
    sec.addEventListener('keydown', function (e) {
      if (!sec.contains(d.activeElement)) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });

    // glisser (souris et doigt) avec élan
    var startX = 0, startY = 0, startPos = 0, dragging = false, lastX = 0, lastT = 0, vel = 0, pid = null;
    function unit() { return style === 'arc' ? geo.R * geo.step : geo.pw + 10; }
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || e.target.closest('.rk-arc__center')) return;
      pid = e.pointerId; startX = lastX = e.clientX; startY = e.clientY; startPos = pos; lastT = performance.now(); vel = 0; dragging = false; moved = false;
      if (anim && anim.stop) anim.stop();
    });
    stage.addEventListener('pointermove', function (e) {
      if (pid !== e.pointerId) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (!dragging) {
        if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) { dragging = true; moved = true; sec.classList.add('is-dragging'); try { stage.setPointerCapture(pid); } catch (er) {} }
        else if (Math.abs(dy) > 10) { pid = null; return; }
        else return;
      }
      var now = performance.now(), dt = Math.max(1, now - lastT);
      vel = 0.8 * vel + 0.2 * (-(e.clientX - lastX) / unit()) / (dt / 1000);
      lastX = e.clientX; lastT = now;
      pos = startPos - dx / unit(); layout();
    });
    function end(e) {
      if (pid !== e.pointerId) return;
      pid = null;
      if (!dragging) return;
      dragging = false; sec.classList.remove('is-dragging');
      var target = Math.round(pos + clamp(vel, -12, 12) * 0.22);
      goTo(target, vel);
      setTimeout(function () { moved = false; }, 60);
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // pavé tactile : défilement horizontal
    var wheelT = 0;
    stage.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      if (anim && anim.stop) anim.stop();
      pos += e.deltaX / unit(); layout();
      clearTimeout(wheelT); wheelT = setTimeout(function () { goTo(Math.round(pos)); }, 140);
    }, { passive: false });

    // en arrivant à l'écran, l'éventail s'ouvre (lié au scroll, réversible)
    var m = M();
    measure(); layout();
    if (!reduce && m && m.scroll) {
      m.scroll(function (p) { spread = 0.62 + 0.38 * (1 - Math.pow(1 - p, 3)); layout(); }, { target: stage, offset: ['start end', 'center center'] });
    } else { spread = 1; layout(); }
    sec.classList.add('is-ready');

    var rt = 0;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { measure(); layout(); }, 120); });
  }

  function start() {
    initH24Word();
    initHero();
    $$('[data-arc]').forEach(initArc);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
  d.addEventListener('shopify:section:load', function (e) { $$('[data-arc]', e.target).forEach(initArc); if (e.target.querySelector('[data-rk-hero]')) initHero(); });
})();
